var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-listado',[_c('page-header',{attrs:{"title":"Duraciones de Contrato"}},[_c('b-button',{attrs:{"variant":"primary","size":"sm","to":"/duracionesContrato/crear"}},[_c('v-icon',{attrs:{"name":"plus","width":"16"}}),_vm._v(" Crear duración de contrato ")],1)],1),_c('tabla',{attrs:{"duraciones-contrato":_vm.duracionesContrato}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }